/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IInstall } from '../models/IInstall';
import type { ILoginResponse } from '../models/ILoginResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class InstallsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns IInstall
     * @throws ApiError
     */
    public getInstallsIndex({
        tenantId,
    }: {
        tenantId: string,
    }): CancelablePromise<Array<IInstall>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/installs',
            query: {
                'tenantId': tenantId,
            },
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public postInstallsCreate({
        requestBody,
    }: {
        requestBody: {
            handshake: string;
            tenantId: string;
            name: string;
        },
    }): CancelablePromise<{
        ok: boolean;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/installs',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public postInstallsDetectInstall({
        requestBody,
    }: {
        requestBody: {
            handshake: string;
            source?: 'bridge';
        },
    }): CancelablePromise<{
        id: string;
        tenantId: string;
        tenantName: string;
        installName: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/installs/detect-install',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ILoginResponse
     * @throws ApiError
     */
    public postInstallsAuthCredentials({
        requestBody,
    }: {
        requestBody: {
            handshake: string;
            username: string;
            password: string;
        },
    }): CancelablePromise<ILoginResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/installs/auth-credentials',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ILoginResponse
     * @throws ApiError
     */
    public postInstallsAuthFp({
        requestBody,
    }: {
        requestBody: {
            handshake: string;
            fmd: string;
        },
    }): CancelablePromise<ILoginResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/installs/auth-fp',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
